export default __webpack_public_path__ + "static/media/list-group-composition.de92a043.svg";